export enum UniswapEventName {
  BalancesReport = 'Balances Report',
  BalancesReportPerChain = 'Balances Report Per Chain',
  TokenSelected = 'Token Selected',
  ConversionEventSubmitted = 'Conversion Event Submitted',
  BlockaidFeesMismatch = 'Blockaid Fees Mismatch',
  LowNetworkTokenInfoModalOpened = 'Low Network Token Info Modal Opened',
  LpIncentiveCollectRewardsButtonClicked = 'LP Incentive Collect Rewards Button Clicked',
  LpIncentiveCollectRewardsErrorThrown = 'LP Incentive Collect Rewards Error Thrown',
  LpIncentiveCollectRewardsRetry = 'LP Incentive Collect Rewards Retry',
  LpIncentiveCollectRewardsSuccess = 'LP Incentive Collect Rewards Success',
  LpIncentiveLearnMoreCtaClicked = 'LP Incentive Learn More CTA Clicked',
  SmartWalletMismatchDetected = 'Smart Wallet Mismatch Detected',
  TooltipOpened = 'Tooltip Opened',
  DelegationDetected = 'Delegation Detected',
  // alphabetize additional values.
}
